import React, { ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Topbar from "../Topbar";
import CustomToast from "../CustomToast";

import { FooterContainer, PageContainer, PageHeaderContainer, PageTitle } from "./styles";
import SideBar from "../SideBar";
import GlobalLayoutFooter from "../GlobalLayoutFooter";
import { useAuth } from "../../hooks/AuthContext";
import { useNavigate } from "react-router-dom";
import { RiArrowLeftLine } from "react-icons/ri";

interface LayoutProps {
  noPadding?: boolean;
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children, noPadding }) => {
  const { navigationAction } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isIframe, setIsIframe] = useState(false);
  const [isDesktopExpanded, setIsDesktopExpanded] = useState(() => {
    const savedState = localStorage.getItem("@FixitApp:SidebarExpanded");
    return savedState !== null ? JSON.parse(savedState) : true;
  });
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("@FixitApp:SidebarExpanded", JSON.stringify(isDesktopExpanded));
  }, [isDesktopExpanded]);

  useEffect(() => {
    if (location.pathname === "/saf") {
      setIsIframe(true);
    } else {
      setIsIframe(false);
    }
  }, [location]);

  // Close mobile menu automatically on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <SideBar 
        extendedMode={isDesktopExpanded} 
        setExtendedMode={setIsDesktopExpanded}
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
      />
      
      <PageContainer
        noPadding={noPadding ?? false}
        isMenuOpen={isMenuOpen}
        isIframe={isIframe}
        isDesktopExpanded={isDesktopExpanded}
      >
        <Topbar 
          isMenuOpen={isMenuOpen} 
          toggleMenu={toggleMenu} 
          extendedMode={isDesktopExpanded} 
          setExtendedMode={setIsDesktopExpanded} 
        />
        <CustomToast />
        <div className="content-area">
          {!!navigationAction && (
            <PageHeaderContainer>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                {!!navigationAction.hasButton && (
                  <>
                    {navigationAction.action === "back" && (
                      <RiArrowLeftLine className="back-btn" onClick={() => navigate(-1)} />
                    )}
                    {navigationAction.action === "function" && (
                      <RiArrowLeftLine className="back-btn" onClick={navigationAction.functionToBeExecuted} />
                    )}
                  </>
                )}
                <PageTitle>{navigationAction.description}</PageTitle>
              </div>

              {navigationAction.customElement && (
                <div className="custom-element-wrapper">
                  {navigationAction.customElement}
                </div>
              )}
            </PageHeaderContainer>
          )}
          {children}
        </div>
        <FooterContainer>
          <GlobalLayoutFooter />
        </FooterContainer>
      </PageContainer>
    </>
  );
};

export default Layout;
